import React from 'react';
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const PromptDialog = ({
    title,
    label,
    description = '',
    cancelButtonLabel,
    okButtonLabel,
    open,
    value,
    currentValues,
    handleSubmit,
    handleOnChange,
    handleClose,
    enforceDuplicateValidation = false,
}) => {
    const isValid =
        !enforceDuplicateValidation ||
        (currentValues?.filter((x) => x.trim().toLocaleLowerCase() === value.trim().toLocaleLowerCase()).length == 0 ??
            true);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            onContextMenu={(e) => {
                e.preventDefault();
                handleClose();
            }}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent sx={{ width: '450px' }}>
                {description && <DialogContentText>{description}</DialogContentText>}
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label={label}
                    isValid={() => isValid}
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={value}
                    onChange={(e) => handleOnChange(e.target.value)}
                    onKeyUp={(event) => event.key === 'Enter' && isValid && handleSubmit(value)}
                />
            </DialogContent>
            {!isValid && (
                <DialogContent sx={{ width: '450px' }}>
                    <DialogContentText style={{ color: 'red' }}>Zones cannot have duplicate names.</DialogContentText>
                </DialogContent>
            )}
            <DialogActions>
                <Button onClick={handleClose}>{cancelButtonLabel}</Button>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!isValid}
                    onClick={() => handleSubmit(value.trim())}
                >
                    {okButtonLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export { PromptDialog };
